export default {"src":"/_next/static/media/visa.9fd12ad7.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};